// components/CaseCard.tsx
import React from 'react';
import { Card, CardActionArea, CardContent, Typography, Box } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { ICaseData } from '../../contexts/CaseTrackingContext';

interface CaseCardProps {
  data: ICaseData;
}

const CaseTrackingCards: React.FC<CaseCardProps> = ({ data }) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(`/case-tracking/${data.receiptNumber}`);
  };

  return (
    <Card sx={{ mb: 2, width: '100%', borderRadius: 2, boxShadow: 3 }}>
      <CardActionArea onClick={handleClick}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 0.5 }}>
          <Typography color="text.secondary" fontWeight={500}>Receipt Number:</Typography>
          <Typography variant="h6">{data.receiptNumber}</Typography>
          {data.submittedDate && (<Typography color="text.secondary"fontWeight={500}>Submitted: {format(new Date(data.submittedDate), "PP")}</Typography>)}
          <Typography color="text.secondary" fontWeight={500}>Form Type: {data.formType}</Typography>
          <Box mt={1} display="flex" alignItems="center">
            <Typography variant="body2">Tracking Enabled:{" "}{data.tracking ? "Yes" : "No"}</Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CaseTrackingCards;
